// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__hynfa","dragIcon":"Choice_dragIcon__2WdLK","left":"Choice_left__1n-ZK","input":"Choice_input__3PFFY"};